const CONFIG_VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL+ '/api/v1/member';

export default {
    // Endpoints
    info: CONFIG_VUE_APP_BASE_URL +'/campaign/info',
}
